import gql from "graphql-tag";

export const GetOwnedProducts = gql`
  query GetOwnedProducts(
    $name: QueryableString
    $price: QueryableFloat
    $createdAt: QueryableDateTime
    $limit: Int
    $cursor: String
  ) {
    stores {
      ownedProducts(
        name: $name
        price: $price
        createdAt: $createdAt
        limit: $limit
        cursor: $cursor
      ) {
        id
        name
        price
        createdAt
        isDonation

        images {
          id
          url
        }

        activeOpportunities {
          id
          isPercentage
          amount
          createdAt
          isActive
        }

        opportunities {
          id
        }

        sales {
          totalSales
          totalRevenue
        }
        variants {
          id
          name
          description
          price
          stock
          sku
          selectedValues {
            id
            name
            option {
              id
              name
            }
          }
        }
      }
    }
  }
`;
